
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import ManifestoPage from '../pages/manifesto/page';
import ContactPage from '../pages/contact/page';
import TransmissionsGalleryPage from '../pages/transmissions-gallery/page';
import TransmissionsPage from '../pages/transmissions/page';
import SentienceSignalsPage from '../pages/sentience-signals/page';
import JournalPage from '../pages/journal/page';
import AskCollectivePage from '../pages/ask-collective/page';
import GalleryPage from '../pages/gallery/page';
import NotFoundPage from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/manifesto',
    element: <ManifestoPage />,
  },
  {
    path: '/sentience-signals',
    element: <SentienceSignalsPage />,
  },
  {
    path: '/transmissions',
    element: <TransmissionsPage />,
  },
  {
    path: '/transmissions-gallery',
    element: <TransmissionsGalleryPage />,
  },
  {
    path: '/journal',
    element: <JournalPage />,
  },
  {
    path: '/ask-collective',
    element: <AskCollectivePage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
